export const setupScrollToTop = () => {
  const hideOrShowScroll = () => {
    if (window.scrollY < 200) {
      el.classList.add(cssHiddenClass)
    } else {
      el.classList.remove(cssHiddenClass)
    }
  }

  const top = 0
  const el = document.getElementById('to-top')

  const cssHiddenClass = 'hidden'
  el.addEventListener('click', (e) => {
    e.preventDefault()

    window.scrollTo(0, top)
  })
  document.addEventListener('scroll', () => {
    hideOrShowScroll()
  })

  hideOrShowScroll()
}
